<mat-card-header class="mb-2 items-center">
    <mat-card-title>
        @if (currentSavedFilter(); as currentSavedFilter) {
            <span>{{ 'Components.SearchFilter.AppliedFilter' | transloco }}:</span>
            <span [class.font-bold]="currentSavedFilter.isDefault">
                {{ currentSavedFilter.isDefault ? ('Components.SearchFilter.DefaultFilter' | transloco) : currentSavedFilter.name }}
            </span>
        } @else {
            <span>{{ 'Components.SearchFilter.Filter' | transloco }}</span>
        }
    </mat-card-title>

    <!-- saving / loading of filters -->
    <div class="ml-auto flex items-center gap-4">
        @if (isSaving()) {
            <mat-spinner diameter="20" />
        } @else {
            @if (!!currentSavedFilter()) {
                <button
                    mat-icon-button
                    (click)="updateCurrentSavedFilter()"
                    [disabled]="!hasUnsavedChanges() || !isValid()"
                    [matTooltip]="'Components.SearchFilter.SaveFilter' | transloco">
                    <mat-icon>save</mat-icon>
                </button>
            }

            <button
                mat-icon-button
                (click)="saveCurrentFilters()"
                [disabled]="!canSave()"
                [matTooltip]="'Components.SearchFilter.SaveFilter' | transloco">
                <mat-icon>save_as</mat-icon>
            </button>
        }

        <button mat-icon-button (click)="reset()" [matTooltip]="'General.Actions.Reset' | transloco">
            <mat-icon>replay</mat-icon>
        </button>
    </div>
</mat-card-header>

<mat-card-content>
    <div class="flex flex-col">
        <!-- readonly filters -->
        @if (readonlyFilters().length > 0) {
            <div class="gap-4">
                <mat-chip-listbox>
                    @for (filter of readonlyFilters(); track filter.internalId; let i = $index) {
                        <mat-chip-option>
                            {{ filter.label }}
                            <button matChipRemove (click)="removeReadOnlyFilter(filter.internalId)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-option>
                    }
                </mat-chip-listbox>
            </div>
        }

        <!-- editable filters -->
        @for (filter of currentFilters(); track filter.internalId; let i = $index) {
            <div class="flex flex-col gap-2">
                @if (i !== 0) {
                    <mat-divider class="!mb-2 !mt-4" />
                }

                <arc-filter-part [filterModel]="filter" [index]="i" [filterProperties]="selectableFilterItems()" />
            </div>
        }
    </div>

    <div class="mt-2 flex items-center gap-2">
        <button mat-button (click)="addFilter()" [disabled]="selectableFilterItems().length === 0">
            <mat-icon>add</mat-icon>
            <span>{{ 'Components.SearchFilter.AddFilter' | transloco }}</span>
        </button>

        <div class="grow"></div>

        <button mat-flat-button color="primary" [disabled]="!canApply()" (click)="applyFilters()">
            <span class="flex gap-2">
                @if (isLoading()) {
                    <mat-spinner color="accent" diameter="20" />
                }

                <!-- displays result count on button, including '+' at the end if the result was capped -->
                {{
                    'Components.SearchFilter.ShowXResults'
                        | transloco: { value: canApply() ? (resultCount() | arcNumber) + (isSearchResultCapHit() ? '+' : '') : '' }
                }}
            </span>
        </button>
    </div>
</mat-card-content>
